module.exports = __webpack_public_path__ + "img/108.bba3186.jpg";